/**
 * Resolves event id for AI chat (params, URL, or loaded Vuex event).
 * @param {object} route - Vue Router `$route`
 * @param {{ id?: string | number } | null | undefined} storeEvent - `events/fetchEvent`
 * @returns {string|null}
 */
export function resolveEventIdForAiChat(route, storeEvent) {
  if (!route) return null;

  const fromParams = route.params && route.params.eventId;
  if (fromParams != null && String(fromParams).trim() !== '') {
    return String(fromParams).trim();
  }

  const path = route.path || '';
  const standard = path.match(/^\/events\/[^/]+\/([^/]+)(?:\/|$)/);
  if (standard) return standard[1];

  const publicEv = path.match(/^\/cc-events\/[^/]+\/([^/]+)(?:\/|$)/);
  if (publicEv) return publicEv[1];

  const looksEventish = /^\/(?:cc-)?events\//.test(path);
  if (looksEventish && storeEvent && storeEvent.id != null && storeEvent.id !== '') {
    return String(storeEvent.id);
  }

  return null;
}
